/* eslint-disable react/jsx-curly-newline */
import React, { FC, ReactElement } from "react";
import { useSelector } from "react-redux";
import { RootState } from "services/redux/rootReducer";
import { Redirect, RouteProps } from "react-router-dom";
import LoadingScreen from "features/shared/screens/loading";
import withAdminNavbar from "features/navbar/wrappers/withAdminNavbar";
import { Roles } from "features/panelManagement/accessManagement/types/access";
import RouteWithErrorBoundary from "./routeWithErrorBoundary";

const PrivateRoute: FC<
    RouteProps & { withNavbar?: boolean; roles?: Roles[] }
> = ({
    children,
    withNavbar = true,
    roles = Object.values(Roles),
    ...delegated
}) => {
    const { isLoggedIn, hasLoaded, role } = useSelector(
        (state: RootState) => state.auth
    );

    if (!hasLoaded) return <LoadingScreen />;

    const renderRoute = () => {
        if (!isLoggedIn)
            return (
                <Redirect
                    to={{
                        pathname: "/login",
                    }}
                />
            );
        if (!roles.includes(role))
            return (
                <Redirect
                    to={{
                        pathname: "/dashboard",
                    }}
                />
            );
        return withNavbar
            ? withAdminNavbar(children as ReactElement)
            : children;
    };

    return <RouteWithErrorBoundary {...delegated} render={renderRoute} />;
};

export default PrivateRoute;
